// extracted by mini-css-extract-plugin
module.exports = {"root":"GjhSLco1cciVFV4MFbF2","signin":"X3HAQf0D75He9NyFWpHJ","demo":"xUeOS7KzouNBqkh1sl2f"};